import * as keyset from 'i18n/Settings';
import { useI18N } from '@yandex-int/i18n/lib/react';
import { Channel, AliceApp } from '../model/skill';
import { routes } from '../lib/routes';
import { MarkedMenuItem } from '../model/menu-item';
import { useMenuItems } from './useMenuItems';

export type SettingsTab = 'main' | 'devices' | 'intents' | 'userAgreements';

const displayDevicesTab = (skill: AliceApp) => {
    return (
        (__appConfig.app.displayDeviceLinking || Boolean(window.sessionStorage.getItem('__display-device-linking'))) &&
        skill.channel === Channel.SmartHome
    );
};

const displayIntentsTab = (skill: AliceApp) =>
    Boolean(__appConfig.app.displayGrammarPage || __appConfig.user.featureFlags.allowUseGrammarPage) &&
    skill.channel === Channel.AliceSkill;

const displayUA = () => __appConfig.user.featureFlags.enableUserAgreements || __appConfig.user.isAdmin;

const isYangoRequest = () => __appConfig.isYangoRequest;

export const useSettingsPageMenuItems = (skill: AliceApp, isDraft = false) => {
    const isTvApp = skill.channel === Channel.TvApp;

    const display: Record<SettingsTab, boolean> = {
        main: true,
        devices: displayDevicesTab(skill),
        intents: displayIntentsTab(skill),
        userAgreements: displayUA(),
    };
    const t = useI18N(keyset);

    const items: Array<MarkedMenuItem<SettingsTab>> = [
        {
            tab: 'main',
            path: isTvApp
                ? routes.app.installableAppSettings(Channel.TvApp, isDraft, 'main', skill.id)
                : routes.app.skillSettings(isDraft, 'main', skill.id),
            title: t('submenu-main'),
            exact: true,
        },
        {
            tab: 'intents',
            path: routes.app.skillSettings(isDraft, 'intents', skill.id),
            title: t('submenu-intents'),
            exact: true,
        },
        {
            tab: 'userAgreements',
            path: isTvApp
                ? routes.app.installableAppSettings(Channel.TvApp, isDraft, 'userAgreements', skill.id)
                : routes.app.skillSettings(isDraft, 'userAgreements', skill.id),
            title: t('submenu-agreements'),
            exact: true,
        },
    ];

    if (!isYangoRequest()) {
        items.splice(1, 0, {
            tab: 'devices',
            path: routes.app.skillSettings(isDraft, 'devices', skill.id),
            title: t('submenu-devices'),
            exact: true,
        });
    }

    return useMenuItems(display, items);
};
